{
  "el": {
    "ai": {
      "assistant": {
        "all_projects": "Όλα τα έργα",
        "cap": {
          "action": "Έναρξη νέας συνομιλίας",
          "message": "Έφτασες στο όριο συνομιλιών."
        },
        "empty_state": {
          "subtitle": "Ρώτησέ με οτιδήποτε για τους πελάτες σου",
          "title": "Πώς μπορώ να σε βοηθήσω;"
        },
        "errors": {
          "budget_reached": "Ο μηνιαίος προϋπολογισμός AI για αυτόν τον χώρο εργασίας έχει εξαντληθεί. Επικοινώνησε με έναν διαχειριστή για την αύξηση του ορίου.",
          "generic": "Κάτι πήγε στραβά. Δοκίμασε ξανά."
        },
        "history": {
          "empty": "Δεν υπάρχουν ακόμα προηγούμενες συνομιλίες",
          "title": "Προηγούμενες συνομιλίες"
        },
        "input": {
          "disclaimer": "Τα αποτελέσματα ενδέχεται να μην είναι ακριβή. Επαλήθευε πάντα τις σημαντικές πληροφορίες.",
          "hint": "Enter για αποστολή · Shift+Enter για νέα γραμμή",
          "placeholder": "Ρώτησε για τους πελάτες σου..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Πώς ρυθμίζω τις ειδοποιήσεις;",
          "help_project_settings": "Πού βρίσκω τις ρυθμίσεις έργου;",
          "open_decisions": "Ποιες αποφάσεις είναι ακόμα ανοιχτές;",
          "unassigned_units": "Ποια ακίνητα δεν έχουν ακόμα πελάτη;"
        },
        "support_cta": {
          "action": "Επικοινωνία με την υποστήριξη",
          "prompt": "Δεν βρήκες την απάντηση που έψαχνες;"
        }
      },
      "settings": {
        "budget": {
          "budget_label": "Προϋπολογισμός",
          "description": "Μηνιαίο ανώτατο όριο κόστους για τη χρήση AI (δοκιμαστική φάση). Επανυπολογίζεται με βάση τη χρήση tokens σε όλες τις συνομιλίες αυτόν τον μήνα.",
          "save": "Αποθήκευση",
          "title": "Μηνιαίος προϋπολογισμός",
          "usage_label": "Χρήση αυτόν τον μήνα"
        },
        "description": "Διαμόρφωση για λειτουργίες AI στον χώρο εργασίας σου.",
        "title": "Ρυθμίσεις AI"
      }
    }
  }
}
